import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["resourceType", "value", "placeholder", "styles", "id", "components"];
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
/**
 * Desc: This component is designed with the sole assumption that a single select will only display a single type of resource.
 * This particular assumption has been leveraged in the caching phenomenon.
 * This particular HOC Performs various tasks based on the given type of the resource which needs to be displayed.
 * 1. Based on the type of the resource it fetches the options for that resource and adds it to the cache.
 * 2. Resolves any and every selected value that needs resolving
 * 3. Based on type automatically get the getOptionLabel and getOptionValue methods.
 *
 * TODO: Default Values need to be handled and pagination needs to be added.
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { defaultMemoize } from 'reselect';
import _noop from 'lodash/noop';
import _isEmpty from 'lodash/isEmpty';
import _debounce from 'lodash/debounce';
import _keyBy from 'lodash/keyBy';

// Services
import { getResourceByType } from '@tekion/tekion-base/services/resourceService';
import { getLookupByKeys } from '@tekion/tekion-base/services/lookupService';

// Constants
import { EMPTY_ARRAY, EMPTY_OBJECT } from '@tekion/tekion-base/app.constants';
import { INITIAL_STATE, INITIAL_VALUES_RESOLVED_STATE } from './constants/withAsyncResource.general';
import RESOURCE_TYPES from './constants/withAsyncResource.resourceTypes';

// Helpers
import getOptionMapperForResource from './helpers/withAsyncResource.optionMapper';
import { getValuesFromCache, getValuesNotInCache } from './helpers/withAsyncResource.general';
import { getOnChangeValue, getLoadingMessage, getNoOptionsMessage } from '../../helpers/advancedSelect.general';
import { getSelectStyles } from '../../helpers/advancedSelect.style';
import MenuPortal from '../../components/MenuPortal';
var REACT_SELECT_CUSTOM_COMPONENTS = {
  MenuPortal: MenuPortal
};
var DEFAULT_DELAY_LOAD_BY = 100;
var withAsyncResource = function withAsyncResource(WrappedComponent) {
  var WithAsyncResource = /*#__PURE__*/function (_Component) {
    _inherits(WithAsyncResource, _Component);
    var _super = _createSuper(WithAsyncResource);
    function WithAsyncResource(props) {
      var _this;
      _classCallCheck(this, WithAsyncResource);
      _this = _super.call(this, props);
      /**
       * This can be stored in instance as we can be rest assured that select will always display a single type of resource.
       */
      _defineProperty(_assertThisInitialized(_this), "getSelectComponents", defaultMemoize(function (userOverideComponents) {
        return _objectSpread(_objectSpread({}, REACT_SELECT_CUSTOM_COMPONENTS), userOverideComponents);
      }));
      _defineProperty(_assertThisInitialized(_this), "getValuesFromCache", defaultMemoize(getValuesFromCache));
      _defineProperty(_assertThisInitialized(_this), "setInitialValuesAsResolved", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _this$props, resourceType, value, resolver, initialValuesResolved, valuesNotInCache, lookupValues;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this$props = _this.props, resourceType = _this$props.resourceType, value = _this$props.value, resolver = _this$props.resolver;
              initialValuesResolved = _this.state.initialValuesResolved;
              /**
               * If the initial values are already resolved then dont do anything.
               */
              if (!initialValuesResolved) {
                _context.next = 4;
                break;
              }
              return _context.abrupt("return");
            case 4:
              /**
               * Get the list of values which are not already in cache.
               */
              valuesNotInCache = getValuesNotInCache(_this.cache, value);
              /**
               * If none of the values need resolving nothing needs to be done.
               */
              if (!_isEmpty(valuesNotInCache)) {
                _context.next = 8;
                break;
              }
              _this.setState(INITIAL_VALUES_RESOLVED_STATE);
              return _context.abrupt("return");
            case 8:
              _context.prev = 8;
              _context.next = 11;
              return resolver(resourceType, valuesNotInCache);
            case 11:
              lookupValues = _context.sent;
              _this.addResourcesInCache(lookupValues);
              _this.setState(INITIAL_VALUES_RESOLVED_STATE);
              _context.next = 19;
              break;
            case 16:
              _context.prev = 16;
              _context.t0 = _context["catch"](8);
              console.error(_context.t0);
            case 19:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[8, 16]]);
      })));
      /**
       * Megers the given styles with the base styles.
       * The base styles can be overriden by the supplied styles.
       */
      _defineProperty(_assertThisInitialized(_this), "getSelectStyles", defaultMemoize(getSelectStyles));
      /**
       * Fetches the list of entities / resources for the particular type
       * Add the fetched resources in the cache
       * If any of the selected values needs special resolving then resolves the required values as well.
       * @param {String} inputString: The search query/string entered by the user.
       * @param {Function} callback: Callback method provided by react select to which we pass in the fetched resources.
       */
      _defineProperty(_assertThisInitialized(_this), "handleLoadOptions", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var inputString,
          callback,
          _this$props2,
          resourceType,
          service,
          resources,
          cleanedUpResources,
          _args2 = arguments;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              inputString = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : '';
              callback = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : _noop;
              _this$props2 = _this.props, resourceType = _this$props2.resourceType, service = _this$props2.service;
              _context2.prev = 3;
              _context2.next = 6;
              return service(resourceType, inputString);
            case 6:
              resources = _context2.sent;
              _this.addResourcesInCache(resources);
              _this.setInitialValuesAsResolved();

              // TEMP - removing empty objects from the array - not sure of the reason why its present
              cleanedUpResources = resources.filter(function (value) {
                return Object.keys(value).length !== 0;
              });
              callback(cleanedUpResources);
              _context2.next = 16;
              break;
            case 13:
              _context2.prev = 13;
              _context2.t0 = _context2["catch"](3);
              console.error(_context2.t0);
            case 16:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[3, 13]]);
      })));
      /**
       * Gets the value strings for the selected option and adds it to the onChange parameters.
       * @param {Object / Array} option: Selected option or list of options.
       */
      _defineProperty(_assertThisInitialized(_this), "handleChange", function (option, eventDetails) {
        var onChange = _this.props.onChange;
        var getOptionValue = _this.optionMapper.getOptionValue;
        var value = getOnChangeValue(getOptionValue, option);
        onChange({
          value: value,
          option: option,
          eventDetails: eventDetails
        });
      });
      _this.optionMapper = getOptionMapperForResource(props.resourceType, props.resourceParams);
      /**
       * This is our temp cache which will me mutated hence it is not EMPTY_OBJECT_READONLY;
       * This is right now temporary, once we have a standard caching algo we can redirect the function to update the new cache.
       */
      _this.cache = props.initialCache;

      /**
       * This state is basically used to keep a track whether the initial values supplied to the select in edit mode have been resolved or not.
       */
      _this.state = INITIAL_STATE;
      _this.debouncedHandleLoadOptions = _debounce(function () {
        var _this2;
        (_this2 = _this).handleLoadOptions.apply(_this2, arguments);
      }, props.delayLoadBy); // if the delayLoadBy is >500, pass {leading:true} as this
      return _this;
    }
    _createClass(WithAsyncResource, [{
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        var initialCache = this.props.initialCache;
        if (prevProps.initialCache !== initialCache) {
          this.cache = _objectSpread(_objectSpread({}, initialCache), this.cache);
          this.forceUpdate();
        }
      }
    }, {
      key: "addResourcesInCache",
      value:
      /**
       * Indexes the resources fetched for the particular type of resource and adds them to the cache.
       * @param {Array} resources: An array of entities fetched for that particular resource type.
       */
      function addResourcesInCache() {
        var resources = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : EMPTY_ARRAY;
        var getOptionValue = this.optionMapper.getOptionValue;
        var keyedResourcesById = _keyBy(resources, getOptionValue);
        this.cache = _objectSpread(_objectSpread({}, this.cache), keyedResourcesById);
      }
    }, {
      key: "render",
      value: function render() {
        var _this$props3 = this.props,
          resourceType = _this$props3.resourceType,
          value = _this$props3.value,
          placeholder = _this$props3.placeholder,
          styles = _this$props3.styles,
          id = _this$props3.id,
          components = _this$props3.components,
          restProps = _objectWithoutProperties(_this$props3, _excluded);
        var initialValuesResolved = this.state.initialValuesResolved;
        var selectValues = initialValuesResolved ? this.getValuesFromCache(this.cache, value) : value;
        var selectStyles = this.getSelectStyles(styles);
        return /*#__PURE__*/React.createElement(WrappedComponent, _extends({}, restProps, this.optionMapper, {
          loadingMessage: getLoadingMessage,
          loadOptions: this.debouncedHandleLoadOptions,
          noOptionsMessage: getNoOptionsMessage,
          onChange: this.handleChange,
          placeholder: placeholder,
          styles: selectStyles,
          value: selectValues,
          id: id,
          inputId: id,
          components: this.getSelectComponents(components)
        }));
      }
    }]);
    return WithAsyncResource;
  }(Component);
  WithAsyncResource.propTypes = {
    resourceType: PropTypes.oneOf(Object.values(RESOURCE_TYPES)).isRequired,
    resourceParams: PropTypes.object,
    value: PropTypes.array,
    onChange: PropTypes.func,
    placeholder: PropTypes.string,
    service: PropTypes.func,
    initialCache: PropTypes.object,
    resolver: PropTypes.func,
    styles: PropTypes.object,
    id: PropTypes.string,
    defaultOptions: PropTypes.bool,
    delayLoadBy: PropTypes.number
  };
  WithAsyncResource.defaultProps = {
    value: EMPTY_ARRAY,
    onChange: _noop,
    placeholder: __('Select'),
    service: getResourceByType,
    initialCache: EMPTY_OBJECT,
    resolver: getLookupByKeys,
    styles: EMPTY_OBJECT,
    id: '',
    resourceParams: EMPTY_OBJECT,
    defaultOptions: true,
    delayLoadBy: DEFAULT_DELAY_LOAD_BY
  };
  return WithAsyncResource;
};
export default withAsyncResource;